export type CatPart = 'ears' | 'head-body' | 'paws' | 'tail';

export const CAT_PART_MAP = new Map<number, CatPart>([
  ...[0, 7, 10, 11, 16, 17].map((bucket): [number, CatPart] => [bucket, 'ears']),
  ...[
    20, 21, 22, 23, 24, 25, 26, 27, 30, 31, 33, 34, 36, 37, 41, 42, 43, 44, 45, 46, 52, 53, 54, 62,
    63, 64, 65, 73, 74, 75, 76, 83, 84, 85, 86,
  ].map((bucket): [number, CatPart] => [bucket, 'head-body']),
  ...[92, 93, 95, 96].map((bucket): [number, CatPart] => [bucket, 'paws']),
  ...[59, 68, 69, 78, 87].map((bucket): [number, CatPart] => [bucket, 'tail']),
]);

export const CAT_BUCKETS = [...CAT_PART_MAP.keys()];
